// Copyright (c) 2016 Deere & Company

import AdditionalDetailsDataTypeDomain, {getDefaultState as getAdditionalDetailsDataTypeDomain} from '../state/additional-data-type-domain';
import actions from '../../actions-list';

const setRgaAdditionalDataTypeDomain = (state, action) =>
    AdditionalDetailsDataTypeDomain.update(state, {
        $set: action.rgaAdditionalDataType
    });

export default (state = getAdditionalDetailsDataTypeDomain(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_ADDITIONAL_DATA_TYPE_DOMAIN]: setRgaAdditionalDataTypeDomain
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/additional-data-type-domain.js